import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'aa-lack-of-data',
    templateUrl: './lack-of-data.component.html',
    styleUrls: [
        './lack-of-data.component.scss'
    ],
    standalone: false
})
export class LackOfDataComponent implements OnInit
{
    @Input() title: string = '';
    @Input() message: string = '';

    constructor() { }

    ngOnInit ()
    {
    }
}
